import { trimStart } from "lodash-es"
import { useMemo } from "react"


import { ContextItemPill } from "@/components/Chat/ContextItemPill.tsx"
import { Ellipsis, EllipsisContainer } from "@/components/Ellipsis/Ellipsis.ts"
import { Tooltip } from "@/components/Tooltip/Tooltip.tsx"
import { FilePlainRegular, FolderRegular, Icon20 } from "@/icons/Icons.ts"
import { displayName } from "@/lib/displayUtils.ts"

import type { AiAgentTaskContextItem } from "@/lib/client/generated/TypeDefinitions.ts"

export const RelevantFiles = (props: {
  files: AiAgentTaskContextItem[]
}) => {
  const sortedFiles = useMemo(() => props.files.slice().sort((a, b) => {
    return a.name.localeCompare(b.name)
  }), [props.files])

  return (
    <>
      {sortedFiles.map(item => <RelevantFile key={item.name} file={item} />)}
    </>
  )
}

const RelevantFile = (props: {
  file: AiAgentTaskContextItem
}) => {
  const tooltipContent = trimStart(props.file.name, "/")

  return tooltipContent.includes("/")
    ? (
      <Tooltip content={tooltipContent}>
        <ContextItemPill withRemoveIcon={false}>
          <RelevantFileIcon {...props} />
          <RelevantFileName {...props} />
        </ContextItemPill>
      </Tooltip>
    )
    : (
      <ContextItemPill withRemoveIcon={false}>
        <RelevantFileIcon {...props} />
        <RelevantFileName {...props} />
      </ContextItemPill>
    )
}

const RelevantFileIcon = (props: {
  file: AiAgentTaskContextItem
}) => {
  if (props.file.name.endsWith("/") || props.file.type == "DIR") {
    return <FolderRegular className={Icon20} />
  } else {
    return <FilePlainRegular className={Icon20} />
  }
}

const RelevantFileName = (props: {
  file: AiAgentTaskContextItem
}) => {
  return (
    <EllipsisContainer>
      <Ellipsis>
        {getDisplayName(props.file.name)}
      </Ellipsis>
    </EllipsisContainer>
  )
}

function getDisplayName(filePath: string): string {
  return filePath.endsWith("/") ? filePath.slice(0, -1) : displayName(filePath)
}
